export function validatePosthogHost(key: string | undefined, host: string | undefined): void {
  if (!key?.trim()) return;
  let url: URL;
  try {
    url = new URL(host ?? '');
  } catch {
    throw new Error('VITE_POSTHOG_HOST must be an absolute URL when VITE_POSTHOG_KEY is set');
  }
  const localHttp =
    url.protocol === 'http:' && ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname);
  if (url.protocol !== 'https:' && !localHttp) {
    throw new Error('VITE_POSTHOG_HOST must use HTTPS (or HTTP on localhost)');
  }
  if (url.username || url.password || url.search || url.hash) {
    throw new Error(
      'VITE_POSTHOG_HOST must not contain credentials, query parameters or a fragment',
    );
  }
}
